import { FC } from 'react';
import Container from '~/components/Container';
import styles from './Brand.module.scss';
import classNames from 'classnames';

interface BrandProps {
    data?: any
}

const Brand: FC<BrandProps> = ({ data }) => {

    const newHtml = (html: string) => {
        ['first_brand', 'brand_item'].forEach((item) => {
            html = html.replaceAll(item, styles[item]);
        });
        return html;
    };

    if (!data?.content) return null;

    return (
        <Container rootClassName={styles.brand_wrapper}>
            <div className={classNames('grid gap-2 grid-cols-1 lg:grid-cols-2', styles.brand)} dangerouslySetInnerHTML={{ __html: newHtml(data?.content ?? "") }} />
        </Container>
    );
};

export default Brand;
